// OpenAI api model
import mongoose from 'mongoose'
const { Schema } = mongoose;


const ConversationSchema = new Schema({
	user_id: {
		type:String,
		ref: 'User',
	},
	input: {
		type: String,
	},
	output: {
		type: String,
	},
	date: {
		type: Date,
		default: Date.now,
	},
});
 mongoose.model('Conversation',ConversationSchema, 'conversations');

export default ConversationSchema